export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/landscape.37d2a2b9-e6402b.png";